import { render } from "./index.vue?vue&type=template&id=b24cfbb2&ts=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Pages/Configuration/Users/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b24cfbb2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b24cfbb2', __exports__)) {
    api.reload('b24cfbb2', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=b24cfbb2&ts=true", () => {
    api.rerender('b24cfbb2', render)
  })

}


export default __exports__